<div *ngIf="userType == 'investor'"><nz-input-group nzPrefixIcon="search" class="search-dropdown">
    <!-- (nzOnSearch)="searchInvestor($event)" nzServerSearch [nzDropdownRender]="renderTemplate"-->
    <nz-select nzShowSearch [nzDropdownClassName]="'disable-dropdown'" nzPlaceHolder="Search in Database..."
      [(ngModel)]="inputValue" class=" hideArrow" [nzOpen]="isOpenDropdown" (nzOpenChange)="onDropdownOpen($event)"
      (nzOnSearch)="searchInvestor($event)" nzServerSearch [nzNotFoundContent]="renderTemplate">
      <ng-template></ng-template>
      <ng-container *ngIf="!isLoading">
        <nz-option *ngFor="let investor of investorsDBList" [nzLabel]="investor.investorDisplayName" nzCustomContent [nzValue]="investor._id"
          nzDisabled>
          <span class="d-flex justify-content-space-between w-70"><span class="ellipsis-text">{{investor.companyName + '
              | ' + investor.investorDisplayName}}</span>
            <span *ngIf="siteDetails?.NonAlcStatus && investor.isNonAlc" class="program-box m-0 w-55"> Non-alc
            </span></span> <button nz-button nzType="primary" class="btn-option" (click)="addInvestorToList(investor)"
            *ngIf="canAddInvestor" [disabled]="investor.isAlreadyAdded || investor._id == currentAddingInvestor?._id"
            [nzLoading]="isDeletingInvestor && investor._id == currentAddingInvestor._id">
            {{!investor.isAlreadyAdded ? 'Add' : 'Added'}}
          </button></nz-option>
        <nz-option nzCustomContent nzDisabled><a *ngIf="canAddInvestor" (click)="showInvestorModal()"><i nz-icon class="pr-1"
              nzType="plus" nzTheme="outline"></i>Create New Investor</a></nz-option>
      </ng-container>
      <nz-option *ngIf="isLoading" nzCustomContent nzDisabled>
        <span nz-icon nzType="loading" class="loading-icon"></span>
        Loading Data...
      </nz-option>
      <ng-template #renderTemplate>
        <span>No investor found with the searched name. Create a New One!</span>
        <span *ngIf="!isLoading">
          <!-- && investorsDBList?.length == 0 -->
          <a class="create-new-ivestor-btn" *ngIf="canAddInvestor" (click)="showInvestorModal()"><i nz-icon class="pr-1"
              nzType="plus" nzTheme="outline"></i>Create New Investor</a>
        </span>
      </ng-template>
    </nz-select>
  </nz-input-group>
</div>
<nz-modal nzClassName="investorModal investor-modal-box-main" [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false" [nzWidth]="850" nzCentered [nzVisible]="isVisibleInvestorDrawer"
  [nzTitle]="'Create New Investor'" [nzFooter]="null" (nzOnCancel)="hideInvestorDrawer(null)">
  <ng-container *nzModalContent>
    <app-add-investor-form [IsDrawer]="false" (investorData)="hideInvestorDrawer($event)"></app-add-investor-form>
  </ng-container>
</nz-modal>
<div *ngIf="userType == 'vendor'">
  <!-- [nzDropdownRender]="renderTemplate" -->
  <nz-input-group nzPrefixIcon="search" class="search-dropdown">
    <nz-select nzShowSearch [nzDropdownClassName]="'disable-dropdown'" nzPlaceHolder="Search in Database..."
      [(ngModel)]="inputValue" nzServerSearch class="hideArrow" (nzOnSearch)="searchVendor($event)"
      [nzOpen]="isOpenDropdown" (nzOpenChange)="onDropdownOpen($event)" [nzNotFoundContent]="renderTemplate">
      <ng-container *ngIf="!isLoading">
        <nz-option *ngFor="let vendor of vendorsDBList" [nzLabel]="vendor.VendorDisplayName" nzCustomContent [nzValue]="vendor._id"
          nzDisabled><span class="w-70 d-flex ellipsis-text align-i-c">
            <span class="pr-1">{{vendor.VendorDisplayName}}</span> <span *ngIf="vendor.CompanyName" class="cl-gray">{{ '
              | ' }}<span class="pl-1">{{ vendor.CompanyName}}</span></span></span> <button nz-button nzType="primary"
            class="btn-option" *ngIf="canAddVendor" (click)="addVendorToList(vendor)"
            [nzLoading]="isDeletingVendor && vendor._id == currentAddingVendor._id"
            [disabled]="vendor?.IsAlreadyAdded == true">{{vendor?.IsAlreadyAdded == true ? 'Added' : 'Add' }}
          </button></nz-option>
          <nz-option nzCustomContent nzDisabled><a *ngIf="canAddVendor" (click)="showVendorModal()"><i nz-icon nzType="plus" class="pr-1"
            nzTheme="outline"></i>Create New Vendor</a></nz-option>
      </ng-container>
      <nz-option *ngIf="isLoading" nzCustomContent nzDisabled>
        <span nz-icon nzType="loading" class="loading-icon"></span>
        Loading Data...
      </nz-option>
      <ng-template #renderTemplate>
        <span> No vendor found with the searched name. Create a New One!</span>
        <span *ngIf="!isLoading">
          <a class="create-new-ivestor-btn" *ngIf="canAddVendor" (click)="showVendorModal()"><i nz-icon nzType="plus" class="pr-1"
              nzTheme="outline"></i>Create New Vendor</a>
        </span>
      </ng-template>
    </nz-select>
  </nz-input-group>
</div>

<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
  [nzVisible]="isVisibleVendorDrawer" [nzTitle]="'Create New Vendor'" [nzFooter]="null"
  (nzOnCancel)="hideVendorDrawer(null)" nzClassName="padding0 create-new-vendor-main-box">
  <ng-container *nzModalContent>
    <div cdkScrollable>
      <app-add-vendor-form (hideVendorDrawer)="hideVendorDrawer($event)" [isEditVendor]="false"></app-add-vendor-form>
    </div>
  </ng-container>
</nz-modal>